import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import SubHeader, {
    SubHeaderLeft,
    SubHeaderRight,
    SubheaderSeparator,
} from '../../../layout/SubHeader/SubHeader';
import Breadcrumb from '../../../components/bootstrap/Breadcrumb';
import Button from '../../../components/bootstrap/Button';
import Page from '../../../layout/Page/Page';
import Card, {
    CardBody,
    CardFooter,
    CardFooterLeft,
    CardFooterRight,
    CardHeader,
    CardLabel,
    CardTitle,
} from '../../../components/bootstrap/Card';
import Accordion, { AccordionItem } from '../../../components/bootstrap/Accordion';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Textarea from '../../../components/bootstrap/forms/Textarea';
import { dashboardPagesMenu, demoPagesMenu } from '../../../menu';
import { useDropdownListProduct } from '../../../apis/hooks/product';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import Icon from '../../../components/icon/Icon';
import ImageViewer from '../../../ImageViewer';
import Empty from '../../../assets/empty.jpeg';

interface DeleteDataFormValues {
    validationEmail: string;
}

const DeleteDataPage = () => {

  const formik = useFormik<DeleteDataFormValues>({
          initialValues: {
              validationEmail: '',
          },
          validate: (values) => {
              const errors: Partial<Record<keyof DeleteDataFormValues, string>> = {};
              // Validation logic:
  
              if (!values.validationEmail) {
                  errors.validationEmail = 'Email is required';
              }
              return errors;
          },
          onSubmit: (values, { resetForm }) => {
    if (!values.validationEmail) return;

    toast.success(`Your account deletion request has been submitted successfully. Our team will review your request and respond within the 72 hours.`, {
        closeOnClick: true,
        closeButton: true,
    });
             // Clear form after toast
    resetForm();
}
  });
  
  return (
    <PageWrapper isProtected={false}
            title={demoPagesMenu.deleteDataPage.text
            }>
            <SubHeader>
                <SubHeaderLeft>
                    <Breadcrumb
                        list={[
                            {
                                title: 'Delete Data',
                                to: '/deleteData',
                            },
                            {
                                title: 'Delete Data',
                                to: '#',
                            },
                        ]}
                    />
        </SubHeaderLeft>
        </SubHeader>

            <Page container='fluid'>
                <Card tag='form' noValidate onSubmit={formik.handleSubmit}>
                    <CardHeader>
                        <CardLabel>
                            <CardTitle>{'Delete Data'}</CardTitle>
                        </CardLabel>
                    </CardHeader>

                    <CardBody>
                        <FormGroup
                                        id='validationEmail'
                                        label='Email *'
                                        className='col-md-4'>
                                        <Input
                                            {...formik.getFieldProps('validationEmail')}
                                            placeholder='e.g. abc@def.com'
                                        />
                                        {formik.touched.validationEmail &&
                                            formik.errors.validationEmail ? (
                                            <div className='text-danger'>
                                                {formik.errors.validationEmail}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </FormGroup>
                    </CardBody>

                    <CardFooter style={{ flexDirection: 'row' }}>
                        <CardFooterLeft>
                            <Button type='submit' color='primary' className='fs-6'>
                                {'Submit Email ID'}
                            </Button>
                        </CardFooterLeft>
                        <CardFooterRight>
                            <Button
                                type='reset'
                                color='info'
                                isOutline
                                onClick={formik.handleReset}
                                className='fs-5'>
                                Reset
                            </Button>
                        </CardFooterRight>
                    </CardFooter>
                </Card>
            </Page>
        </PageWrapper>
  )
}

export default DeleteDataPage